import React, { Component } from "react";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {Link} from "react-router-dom";
import {withNamespaces} from "react-i18next";
import NetworkResetDeviceForm from "./_form/NetworkResetDeviceForm";

class NetworkResetDeviceCreatePage extends Component {

    render() {
        const { t } = this.props;
        const breadcrumb = [
            { value: 'network-reset-device', path: '/panel/network-reset-device' },
            { value: 'add_network-reset-device', path: '#' }
        ];

        return (
            <div>
                <BreadcrumbExtend items={breadcrumb} />
                <h4>{t('add_network-reset-device')}</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            <Link to="/panel/network-reset-device" className="btn btn-secondary float-right btn-create">
                                <i className="fas fa-undo"> </i> &nbsp; { t('back-to-list') }
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        {/*network device form components*/}
                        <NetworkResetDeviceForm/>
                    </div>
                </div>
            </div>
        )
    }
}
export default withNamespaces()(NetworkResetDeviceCreatePage);
